import React, { useState } from "react";
import { useScrollytellTranslation } from "./scrollytellContext";

export const SectionInsertDivider = ({ index, onInsert }) => {
  const [isHovered, setIsHovered] = useState(false);
  const t = useScrollytellTranslation();

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onInsert}
      data-testid={`insert-section-at-${index}`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onInsert?.();
        }
      }}
      aria-label={`${t("insertSectionHere", "Sett inn seksjon her")} (${index})`}
      style={{
        position: "relative",
        height: "20px",
        margin: "0 auto",
        width: "calc(100% - 24px)",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: 5,
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          height: isHovered ? "2px" : "1px",
          backgroundColor: isHovered ? "#4484F1" : "transparent",
          transition: "all 120ms ease",
        }}
      />
      {isHovered ? (
        <span
          style={{
            position: "relative",
            zIndex: 2,
            backgroundColor: "#4484F1",
            color: "#FFFFFF",
            fontSize: "10px",
            fontWeight: 700,
            borderRadius: "12px",
            padding: "2px 8px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.35)",
            whiteSpace: "nowrap",
          }}
        >
          + {t("insertSectionHere", "Sett inn her")}
        </span>
      ) : (
        <div
          style={{
            width: "16px",
            height: "2px",
            backgroundColor: "rgba(255, 255, 255, 0.15)",
            borderRadius: "1px",
          }}
        />
      )}
    </div>
  );
};
